import { db } from '../firebase'
import swal from 'sweetalert2/dist/sweetalert2.all.min.js'
import _ from 'lodash'

export const ADD_USER = 'ADD_USER'
export const ADD_USER_ERROR = 'ADD_USER_ERROR'
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS'
export const FETCH_USERS = 'FETCH_USERS'
export const FETCH_USERS_LOADING = 'FETCH_USERS_LOADING'
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS'
export const DELETE_USER = 'DELETE_USER'
export const DELETE_USER_CONFIRM = 'DELETE_USER_CONFIRM'
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS'
export const MODIFY_USER = 'MODIFY_USER'
export const MODIFY_USER_SUCCESS = 'MODIFY_USER_SUCCESS'

export const addUser = (user, cb) => {
  return dispatch => {
    swal({
      title: "Ajouter l'utilisateur ?",
      text: "Vous êtes sur le point d'ajouter un utilisateur.",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: "Oui, l'ajouter"
    }).then(result => {
      if (result.value) {
        db.collection('users')
          .add({
            email: _.trim(user.email),
            createdAt: Date.now(),
            firstname: user.firstname,
            lastname: user.lastname,
            company: user.company,
            job: user.job,
            tel: user.tel,
            adress: user.adress
          })
          .then(() => {
            dispatch(addUserSuccess(true))
            swal('Ajouter!', "L'utilisateur à bien été ajouté.", 'success')
            if (cb) {
              cb()
            }
          })
          .catch(err => {
            console.error('An error occured: ', err)
            swal(
              'Annulé',
              'Une erreur est survenu, veuillez réessayer.',
              'error'
            )
          })
      }
    })
  }
}

const addUserError = bool => {
  return {
    type: ADD_USER_ERROR,
    hasError: bool
  }
}

const addUserSuccess = bool => {
  return {
    type: ADD_USER_SUCCESS,
    addUserSuccess: bool
  }
}

export const fetchUsersSuccess = users => {
  return {
    type: FETCH_USERS_SUCCESS,
    users
  }
}

export const usersLoading = bool => {
  return {
    type: FETCH_USERS_LOADING,
    isLoading: bool
  }
}

export const fetchUsers = () => {
  return dispatch => {
    dispatch(usersLoading(true))
    let users = []
    // console.log('users fetching...')
    db.collection('users').onSnapshot(
      function(doc) {
        users = doc.docs.map(x => {
          let user = {}
          user = x.data()
          user.id = x.id
          return user
        })
        dispatch(usersLoading(false))
        dispatch(fetchUsersSuccess(users))
      },
      function(error) {
        console.error(error)
      }
    )
  }
}

export const deleteUserSuccess = item => {
  return {
    type: DELETE_USER_SUCCESS,
    item
  }
}

export const deleteUser = id => {
  let item = {}
  return dispatch => {
    db.collection('users')
      .doc(id)
      .get()
      .then(doc =>
        doc.exists ? (item = doc.data()) : console.log('No such document')
      )
    swal({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(
      function() {
        db.collection('users')
          .doc(id)
          .delete()
        swal('Supprimer!', "L'utilisateur à bien été supprimé.", 'success')
          .then(item => dispatch(deleteUserSuccess(item)))
          .catch(err => console.log('error: ', err))
      },
      function(dismiss) {
        if (dismiss === 'cancel') {
          swal('Annulé', "L'utilisateur n'as pas été supprimé.", 'error')
        }
      }
    )
  }
}

export const modifyUserSuccess = userId => {
  return {
    type: MODIFY_USER_SUCCESS,
    userId
  }
}
export const modifyUserError = bool => {
  return {
    type: MODIFY_USER_SUCCESS,
    hasError: bool
  }
}



// WEBPACK FOOTER //
// ./src/actions/user.js